export default defineNuxtPlugin(({ vueApp }) => {
  const uid = () => Date.now().toString(36) + Math.random().toString(36).substring(2)
  vueApp.directive("uid", {
    created(el, binding) {
      const localUid = uid();
      el.setAttribute('id', el.id || localUid);
      switch(binding.arg) {
        case "name":
          const name = el.name || el.id || localUid;
          el.setAttribute('name', name);
        break;
      }
    }   
  })

  vueApp.directive('focus', {
    mounted: (el) => {
      el.focus()
    }
  });

  vueApp.directive('intersect', {
    mounted(el, binding) {
      const modifiers = binding.modifiers || {}
      const value = binding.value
      const options = {
        threshold: 1.0
      };
      const { handler } = typeof value === 'object'
        ? value
        : {
          handler: value
        }
      const observer = new IntersectionObserver((
        entries,
        observer
      ) => {
        /* istanbul ignore if */
        if (!el._observe) { return } // Just in case, should never fire

        // If is not quiet or has already been
        // initted, invoke the user callback
        if (
          handler && (
            !modifiers.quiet ||
            el._observe.init
          )
        ) {
          const isIntersecting = Boolean(entries.find(entry => entry.isIntersecting))

          handler(entries, observer, isIntersecting)
        }

        // If has already been initted and
        // has the once modifier, unbind
        if (el._observe.init && modifiers.once) {
          this.unbind(el)
        } else { el._observe.init = true }
      }, options)
      el._observe = { init: false, observer }

      observer.observe(el)
    },
    unmounted(el) {
      if (!el._observe) { return }
      el._observe.observer.unobserve(el)
      delete el._observe
    }
  });
});
